import React from 'react';
import { CarouselBlockComponentInterface } from "@/types/strapi-dynamic";
import { StrapiImage } from "@/comp/_Utility/StrapiImage";

interface Props {
    data: CarouselBlockComponentInterface;
    color: { bg: string; text: string };
}

export default function CarouselComponent({ data, color }: Props) {
    return (
        <div className="w-full flex-shrink-0 flex flex-col">

            {/* Image Section - Locked to an ultra-wide cinematic ratio */}
            <div className="relative w-full h-full  bg-gray-900">
                {data.componentImage?.url && (
                    <StrapiImage
                        media={data.componentImage}
                        quality="large"
                        className="w-full h-full object-cover"
                    />
                )}
                <div className={`absolute bottom-0 left-0 w-full h-10 md:h-10 px-6 flex items-center justify-center ${color.bg} ${color.text}`}>
                    {data.componentDescription ? (
                        <p className="text-sm md:text-base font-medium text-center line-clamp-2">
                            {data.componentDescription}
                        </p>
                    ) : (
                        /* Invisible placeholder to maintain layout structure */
                        <span className="hidden"></span>
                    )}
                </div>
            </div>

            {/* Colored Underbar - Fixed small height, always renders */}

        </div>
    );
}
